import {
  NewScheduler,
  OldScheduler,
  TimeInterval,
} from 'apps/webcomponents/src/types/common/maintenanceWindowPatchManagementTypes';

export enum POSTPONE_REBOOT_TYPE {
  TIME = 0,
  BETWEEN = 1,
  AFTER = 2,
}

interface SchedulerSettings {
  enabled: boolean;
  oldScheduler: OldScheduler;
  scheduler: NewScheduler;
}

interface ScanPatchesSettings extends SchedulerSettings {
  useSameSchedule: boolean;
  useFallbackSchedule: boolean;
}

export interface PostponeReboot {
  option: POSTPONE_REBOOT_TYPE;
  between: TimeInterval;
  afterMinutes: number;
}

export interface MaintenanceWindowPreviewPatchManagementWebComponentSchema {
  name: string;
  specifics: {
    scanPatchesSettings: ScanPatchesSettings;
    installPatchesSettings: {
      enabled: boolean;
      updateType: {
        securityPatchesSettings: SchedulerSettings;
        nonSecurityPatchesSettings: SchedulerSettings;
        manuallyApprovedPatchesSettings: SchedulerSettings;
      };
      postponeReboot: PostponeReboot;
    };
  };
}

export interface MaintenanceWindowPreviewPatchManagementWebComponentTemplateData {
  name: string;
  targetedOperations: string;
  patchScope: string;
  recurrence: string;
  reboot: string;
}

export const maintenanceWindowPreviewPatchManagementWebComponentTemplateDataEmptyValue = {
  name: '',
  targetedOperations: '',
  patchScope: '',
  recurrence: '',
  reboot: '',
} as MaintenanceWindowPreviewPatchManagementWebComponentTemplateData;
